<template>
	<nav class="primaryNav">
		<ul ref="listWrap">
			<!-- <li @click="chooseScopeType(null, -1)" :class="['navitem', currentIndex == -1 ? 'active' : '']"> -->
			<li @click="goBusPage()" :class="['navitem', currentIndex == -1 ? 'active' : '']">
				<img src="../../assets/image/i1.png" alt="" />
				<span>机场大巴</span>
			</li>
			<li @click="chooseScopeType(null, -2)" :class="['navitem', currentIndex == -2 ? 'active' : '']" v-if="false">
				<img src="../../assets/image/i4.png" alt="" />
				<span>中山港</span>
			</li>
			<li @click="chooseScopeType(null, -3)" :class="['navitem', currentIndex == -3 ? 'active' : '']">
				<img src="../../assets/image/i2.png" alt="" />
				<span>接送服务</span>
			</li>
			<li @click="chooseScopeType(null, -4)" :class="['navitem', currentIndex == -4 ? 'active' : '']">
				<img src="../../assets/image/i3.png" alt="" />
				<span>机场专车</span>
			</li>
			<li v-for="(item, index) in primaryNavArr" :class="['navitem', currentIndex === index ? 'active' : '']" :key="index" @click="chooseScopeType(item.ID, index)">
				<img v-if="item.IconUrl != null" :src="item.IconUrl" alt="" />
				<img v-else src="../../assets/image/12.jpg" alt="" />
				<span>{{ item.ScopeTypeName }}</span>
			</li>
		</ul>
	</nav>
</template>

<script>
export default {
	data() {
		return {
			currentIndex: -1,
			currentScopeId: 0
		};
	},
	props: {
		primaryNavArr: {
			type: Array
		}
	},
	methods: {
		goBusPage(){
			this.$router.push({
				name: 'BusQueryIndex',
			});
		},
		chooseScopeType(scopeId, index) {
			if (index <= 0 && scopeId == null && index != -3 && index != -4) {
				this.currentIndex = index;
				this.$emit('changedScopeId', index);
			} else if (index == -3) {
				this.$router.push({
					name: 'HqPublicOrderPage',
					params: {
						name: 'zsairport',
						limit: 'limit',
						back: 'back'
					}
				});
			} else if (index == -4) {
				window.location.href = '//www.callmefix.net/wechat/carorder.aspx';
			} else {
				this.currentIndex = index;
				if (this.currentScopeId != this.primaryNavArr[index].ID) {
					this.currentScopeId = this.primaryNavArr[index].ID;
				}
				this.$emit('changedScopeId', this.currentScopeId);
			}
		}
	}
};
</script>

<style scoped lang="less">
@import '../../style/public';
.primaryNav {
	max-width: 100%;
	width: 90%;
	margin: 0 auto;
	overflow-x: auto;
	// &::-webkit-scrollbar{
	//   width: 20px;
	//   background-color: #fff;
	// }
	ul {
		.clearfix;
		overflow-x: hidden;
		// .flex_wrap(@fwVal:wrap);
		// .padding-Lr(0,.45rem);
		li {
			width: 1.8rem;
			float: left;
			text-align: center;
			// .flex_items(20%,0,0,wrap);
			.margin-Tb(0.1rem);
			img {
				display: block;
				.margin-Tb();
				.wh(1.3rem, 1.3rem);
				// .radius(50%);
				// .shadow(5px);
			}
			span {
				.text-style();
				display: inline-block;
				width: 4em;
				font-weight: 400;
				max-width: 4em;
				text-overflow: clip;
				.site_name_w;
			}
		}
	}
	//     .direction-of-prompt-wrap{
	//       position: fixed;
	//       left: 0;
	//       width: 100%;
	//       height: 100%;
	//       z-index:100;
	//       // .flex_wrap(space-between,center);
	//       .iconfont{
	//         position: absolute;
	//         top: 50%;
	//         transform: translateY(-50%);
	//       }
	//       .icon-xiangzuoshuangjiantou{
	//         left: 0;
	//       }
	//       .icon-xiangyoushuangjiantou{
	//         right: 0;
	//       }
	//
	//     }
}
.active {
	// border-bottom: 2px solid #006535;
	.primaryColor-text;
}
</style>



// WEBPACK FOOTER //
// src/components/child-components/ScopePrimaryNav.vue